
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { api } from '../../api/client';
/// post Bestslip

export const PostBestSlipfancy = createAsyncThunk(
  'match/PostBestSlipfancy',
  async (fancypayload, { rejectWithValue }) => {
    try {
      const response = await api.post('/bets/place-fancy', fancypayload);
      return response.data;
    } catch (err) {
      return rejectWithValue(
        err.response?.data?.message
          ? { message: err.response.data.message }
          : { message: 'Failed to place bet' }
      );
    }
  }
);

export const PostBestSlip = createAsyncThunk(
  'match/PostBestSlip',
  async (payload, { rejectWithValue }) => {
    try {
      const response = await api.post('/bets/place', payload);
      return response.data;
    } catch (err) {
      return rejectWithValue(
        err.response?.data?.message
          ? { message: err.response.data.message }
          : { message: 'Failed to place bet' }
      );
    }
  }
);

export const getUserBets = createAsyncThunk(
  'match/getUserBets',
  async ({ userId, matchId }, { rejectWithValue }) => {
    if (!userId) {
      return rejectWithValue({ message: 'User ID is required' });
    }

    try {
      const response = await api.get('/bets/user-bets', {
        params: { userId, matchId }   
      });
      return response.data;
    } catch (err) {
      return rejectWithValue(
        err.response?.data?.message
          ? { message: err.response.data.message }
          : { message: 'Failed to fetch user bets' }
      );
    }
  }
);

export const getfancyUserBets = createAsyncThunk(
  'match/getfancyUserBets',
  async ({ userId, matchId }, { rejectWithValue }) => {
    if (!userId) {
      return rejectWithValue({ message: 'User ID is required' });
    }

    try {
      const response = await api.get('/bets/user-bets/fancy', {
        params: { userId, matchId }   
      });
      return response.data;
    } catch (err) {
      return rejectWithValue(
        err.response?.data?.message
          ? { message: err.response.data.message }
          : { message: 'Failed to fetch user bets' }
      );
    }
  }
);

export const getmaxsession = createAsyncThunk(
  'match/getmaxsession',
  async (matchId, { rejectWithValue }) => {
    if (!matchId) {
      return rejectWithValue({ message: 'matchId ID is required' });
    }

    try {
      const response = await api.get(`/limits/session/${matchId}`);
      return response.data;
    } catch (err) {
      return rejectWithValue(
        err.response?.data?.message
          ? { message: err.response.data.message }
          : { message: 'Failed to fetch max session' }
      );
    }
  }
);

export const getmaxlimits = createAsyncThunk(
  'match/getmaxlimits',
  async (matchId, { rejectWithValue }) => {
    if (!matchId) {
      return rejectWithValue({ message: 'matchId ID is required' });
    }

    try {
      const response = await api.get(`/limits/${matchId}`);
      return response.data;
    } catch (err) {
      return rejectWithValue(
        err.response?.data?.message
          ? { message: err.response.data.message }
          : { message: 'Failed to fetch max limits' }
      );
    }
  }
);


export const AccountStatementdepositewid = createAsyncThunk(
  'match/AccountStatementdepositewid',
  async (userId, { rejectWithValue }) => {
    if (!userId) {
      return rejectWithValue({ message: 'userId is required' });
    }

    try {
      const response = await api.get(`/account-statement/deposit-withdraw/${userId}`);
      return response.data;
    } catch (err) {
      return rejectWithValue(
        err.response?.data?.message
          ? { message: err.response.data.message }
          : { message: 'Failed to fetch max session' }
      );
    }
  }
)

export const AccountStatemetsportfilter = createAsyncThunk(
    'match/AccountStatemetsportfilter',
    async ({ userId, sports }, { rejectWithValue }) => {  
        if (!userId) {
            return rejectWithValue({ message: 'userId is required' });
        }
        if (!sports) {
            return rejectWithValue({ message: 'sports name is required' });
        }

        try {
            const response = await api.get(`/account-statement/${sports}/${userId}`);
            return response.data;
        } catch (err) {
            return rejectWithValue(
                err.response?.data?.message
                    ? { message: err.response.data.message }
                    : { message: 'Failed to fetch sport account statement' }
            );
        }
    }
);

/// bet slip max button api 
export const limitmaxbutton = createAsyncThunk(
  'match/limitmaxbutton',
  async ({ matchId, marketType }, { rejectWithValue }) => {
    if (!matchId || !marketType) {
      return rejectWithValue({ message: 'userId and marketType are required' });
    }

    try {
      const response = await api.get(`/limits/match/${matchId}/${marketType}`);
      return response.data;
    } catch (err) {
      return rejectWithValue(
        err.response?.data?.message
          ? { message: err.response.data.message }
          : { message: 'Failed to fetch max session' }
      );
    }
  }
);


export const limitdata = createAsyncThunk(
  'match/limitdata',
  async ( matchId , { rejectWithValue }) => {

    try {
      const response = await api.get(`/limits/match/${matchId}`);
      return response.data;
    } catch (err) {
      return rejectWithValue(
        err.response?.data?.message
          ? { message: err.response.data.message }
          : { message: 'Failed to fetch max session' }
      );
    }
  }
);




export const getwintosshide = createAsyncThunk(
  'match/getwintosshide',
  async (matchId, { rejectWithValue }) => {
    if (!matchId) {
      return rejectWithValue({ message: 'userId and marketType are required' });
    }
    try {
      const response = await api.get(`/sports/toss/${matchId}`);
      return response.data;
    } catch (err) {
      return rejectWithValue(
        err.response?.data?.message
          ? { message: err.response.data.message }
          : { message: 'Failed to fetch max session' }
      );
    }
  }
);



export const getrunamout = createAsyncThunk(
  'match/getrunamout',
  async ({ userId, matchId, selection }, { rejectWithValue }) => {
    try {
      const response = await api.post(`/bets/session-book`, {
        userId,
        matchId,
        selection,
      });
      return response.data;
    } catch (err) {
      return rejectWithValue(
        err.response?.data?.message
          ? { message: err.response.data.message }
          : { message: 'Failed to fetch max session' }
      );
    }
  }
);



const matchSlice = createSlice({
  name: 'match',
  initialState: {
    data: [],
    getuserbetsdata:[],
    getfancybetsdata:[],
    depositewidData:[],
    sportfilterData:[],
    limitdata:[],
    getrunamoutData:[],
    limitmaxbuttonData:[],
    getwintosshideData:[],
    editLimit:{},
    maxlimit:[],
    maxsession:[],
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      ////  post  btesslip
      .addCase(PostBestSlip.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(PostBestSlip.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload ?? [];
      })
      .addCase(PostBestSlip.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload?.message || 'Something went wrong';
      })


         ////  post fancy   btesslip
      .addCase(PostBestSlipfancy.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(PostBestSlipfancy.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload ?? [];
      })
      .addCase(PostBestSlipfancy.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload?.message || 'Something went wrong';
      })
      ///// get matxh bets uswer
      .addCase(getUserBets.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getUserBets.fulfilled, (state, action) => {
        state.loading = false;
        state.getuserbetsdata = action.payload || [];
      })
      .addCase(getUserBets.rejected, (state, action) => {
        state.loading = false;
        state.error =
          action.payload?.message ||
          action.error?.message ||
          'Something went wrong';
      })

       ///// fancy get matxh bets uswer
      .addCase(getfancyUserBets.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getfancyUserBets.fulfilled, (state, action) => {
        state.loading = false;
        state.getfancybetsdata = action.payload || [];
      })
      .addCase(getfancyUserBets.rejected, (state, action) => {
        state.loading = false;
        state.error =
          action.payload?.message ||
          action.error?.message ||
          'Something went wrong';
      })


      ///// get max session/////
      .addCase(getmaxsession.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getmaxsession.fulfilled, (state, action) => {
        state.loading = false;
        state.maxsession = action.payload || [];
      })
      .addCase(getmaxsession.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload?.message ||action.error?.message ||'Something went wrong';
      })

       ///// get max Limit////
      .addCase(getmaxlimits.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getmaxlimits.fulfilled, (state, action) => {
        state.loading = false;
        state.maxlimit = action.payload || [];
      })
      .addCase(getmaxlimits.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload?.message ||action.error?.message ||'Something went wrong';
      })
             ///// AccountStatementdepositewid////
      .addCase(AccountStatementdepositewid.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(AccountStatementdepositewid.fulfilled, (state, action) => {
        state.loading = false;
        state.depositewidData = action.payload || [];
      })
      .addCase(AccountStatementdepositewid.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload?.message ||action.error?.message ||'Something went wrong';
      })

            ///// AccountStatementspoerts filter////
       .addCase(AccountStatemetsportfilter.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(AccountStatemetsportfilter.fulfilled, (state, action) => {
        state.loading = false;
        state.sportfilterData = action.payload || [];
      })
      .addCase(AccountStatemetsportfilter.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload?.message ||action.error?.message ||'Something went wrong';
      })

            /////  bet slip max buttonn ////
       .addCase(limitmaxbutton.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(limitmaxbutton.fulfilled, (state, action) => {
        state.loading = false;
        state.limitmaxbuttonData = action.payload || [];
      })
      .addCase(limitmaxbutton.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload?.message ||action.error?.message ||'Something went wrong';
      })

      /////  Hide win the toss  manually ////
     .addCase(getwintosshide.pending, (state) => {
            state.loading = true;
            state.error = null;
        })
        .addCase(getwintosshide.fulfilled, (state, action) => {
            state.loading = false;
            state.getwintosshideData = Array.isArray(action.payload) 
                ? action.payload 
                : [action.payload].filter(Boolean);  
        })
        .addCase(getwintosshide.rejected, (state, action) => {
            state.loading = false;
            state.error = action.payload?.message || action.error?.message || 'Something went wrong';
           
        })

        /////  limit data////
     .addCase(limitdata.pending, (state) => {
            state.loading = true;
            state.error = null;
        })
        .addCase(limitdata.fulfilled, (state, action) => {
            state.loading = false;
           state.limitdata = action.payload || [];
        })
        .addCase(limitdata.rejected, (state, action) => {
            state.loading = false;
            state.error = action.payload?.message || action.error?.message || 'Something went wrong';
           
        })
///runamount
        .addCase(getrunamout.pending, (state) => {
    state.runAmountLoading = true;
    state.runAmountError = null;
})
.addCase(getrunamout.fulfilled, (state, action) => {
    state.runAmountLoading = false;
    state.getrunamoutData = action.payload || [];
})
.addCase(getrunamout.rejected, (state, action) => {
    state.runAmountLoading = false;
    state.runAmountError = action.payload?.message || action.error?.message || 'Something went wrong';
});

    
  },
});

export default matchSlice.reducer;
